import React, { FC } from 'react';
import { Form, InjectedFormProps, reduxForm } from 'redux-form';
import { ContactUsFormValues } from '../../types';
import { useTranslationAPI } from '../../../../translations';
import { FormField } from '../../../../../components/CustomForm';
import { codes } from '../../../../../data/translations';
import TextboxAdapter from '../../../../../components/adapters/form/Textbox';
import TextareaAdapter from '../../../../../components/adapters/form/Textarea';
import { email, length, required } from '../../../../../utils/formValidators';
import { issueModuleCodes } from '../../../../../data/translations/issueModuleCodes';
import { CONTACT_US_FORM_NAME, ContactUsFormField } from './const';
import { ControlGroupSection } from '../../../../../components/ControlGroup';
import { Button } from '../../../../../components/Button';

const IssueDetailContactUsFormComponent: FC<React.PropsWithChildren<InjectedFormProps<ContactUsFormValues>>> = ({
	handleSubmit,
	submitting,
}) => {
	const { translate } = useTranslationAPI();

	return (
		<Form onSubmit={handleSubmit}>
			<ControlGroupSection>
				<FormField
					name={ContactUsFormField['userName']}
					component={TextboxAdapter}
					validate={[required(), length({ max: 64 })]}
					controlProps={{ label: translate(codes.common.name), isRequired: true }}
					disabled={submitting}
				/>
				<FormField
					name={ContactUsFormField['organizationName']}
					component={TextboxAdapter}
					validate={length({ max: 64 })}
					controlProps={{ label: translate(codes.organization.singular) }}
					disabled={submitting}
				/>
				<FormField
					name={ContactUsFormField['phone']}
					component={TextboxAdapter}
					validate={[length({ max: 32 })]}
					controlProps={{ label: translate(codes.common.mobile) }}
					componentProps={{ placeholder: translate(codes.common.phoneExample) }}
					disabled={submitting}
				/>
				<FormField
					name={ContactUsFormField['email']}
					component={TextboxAdapter}
					validate={[length({ max: 128 }), required(), email()]}
					controlProps={{ label: translate(codes.common.email), isRequired: true }}
					componentProps={{ placeholder: translate(codes.common.emailExample) }}
					disabled={submitting}
				/>
				<FormField
					name={ContactUsFormField['message']}
					component={TextareaAdapter}
					validate={[length({ max: 2048 }), required()]}
					controlProps={{ label: translate(issueModuleCodes.message), isRequired: true }}
					disabled={submitting}
				/>
				<Button
					primary
					disabled={submitting}
					type={'submit'}
				>
					{translate(codes.common.send)}
				</Button>
			</ControlGroupSection>
		</Form>
	);
};

export const IssueDetailContactUsForm = reduxForm<ContactUsFormValues>({
	form: CONTACT_US_FORM_NAME,
	enableReinitialize: true,
})(IssueDetailContactUsFormComponent);
